(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["account-deletion-request"] && !Shopify.designMode) return;
  try {
    
  function initialiseAccountDeletionForms(root) {
    root.querySelectorAll('[data-account-deletion]').forEach(function (section) {
      var acknowledgement = section.querySelector('[data-deletion-acknowledgement]');
      var confirmation = section.querySelector('[data-deletion-confirmation]');
      var submit = section.querySelector('[data-deletion-submit]');

      if (!acknowledgement || !confirmation || !submit || submit.dataset.initialised === 'true') return;

      submit.dataset.initialised = 'true';

      function updateSubmitState() {
        var isConfirmed = confirmation.value.trim().toUpperCase() === 'DELETE';
        submit.disabled = !acknowledgement.checked || !isConfirmed;
        submit.setAttribute('aria-disabled', submit.disabled ? 'true' : 'false');
      }

      acknowledgement.addEventListener('change', updateSubmitState);
      confirmation.addEventListener('input', updateSubmitState);
      updateSubmitState();
    });
  }

  initialiseAccountDeletionForms(document);
  document.addEventListener('shopify:section:load', function (event) {
    initialiseAccountDeletionForms(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bb-trust-bar"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const stickyBars = [...document.querySelectorAll('.bb-trust-bar--sticky-reassurance')];

    if (stickyBars.length === 0) return;

    const updateStickyTop = () => {
      const header = document.querySelector('.shopify-section--header');
      const headerBottom = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
      const reassuranceHeight = stickyBars[0].querySelector('.bb-trust-bar__reassurance')?.getBoundingClientRect().height || 0;

      document.documentElement.style.setProperty('--bb-trust-reassurance-height', `${reassuranceHeight}px`);

      stickyBars.forEach((bar) => {
        bar.style.setProperty('--bb-trust-sticky-top', `${headerBottom}px`);
      });
    };

    let frame;
    const requestUpdate = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(updateStickyTop);
    };

    updateStickyTop();
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
  })();

  } catch(e) { console.error(e); }
})();
})();
